<template>
  <v-container fluid pa-0>
    <v-layout
      row
      wrap
      align-center
      justify-space-around
      style="min-height:140px"
      class="secondary darken-1"
    />
    <v-dialog
      v-if="show"
      v-model="show"
      max-width="800px"
      transition="dialog-transition"
    >
      <newRole
        @saved="saved"
        @closed="reset"
        :role="roleForEdit"
        v-if="can('add_roles') || can('edit_roles')"
      />
    </v-dialog>
    <v-layout row wrap justify-center style="margin-top:-54px">
      <v-card class="flex xs12 sm11 shadow">
        <v-toolbar color="white" flat height="54px">
          <div class="di-flex align-center">
            <v-icon size="35px">mdi-account-check</v-icon>
            <span class="subheading font-weight-bold  mt-2 ml-2">{{
              $t("roles")
            }}</span>
          </div>
          <v-spacer />
          <v-btn
            icon
            small
            class="shadow-md"
            @click="show = true"
            v-if="can('add_roles')"
            color="btn_color secondary"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider />
        <v-expansion-panel class="flex xs12 shadow text-xs-right">
          <v-expansion-panel-content v-for="item in items" :key="item.id">
            <div slot="header" class="flex-row">
              <span class="IR_M">{{ item.name }}</span>
              <v-spacer />
            </div>
            <viewRole
              @edit="setForEdit(item)"
              @delete="setForDelete(item)"
              :permissions="item.permissions"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import newRole from "./newRole.vue";
import viewRole from "./viewRole.vue";

export default {
  name: "roles",
  components: { viewRole, newRole },
  data() {
    return {
      items: [],
      show: false,
      loading: true,
      deleteId: null,
      edit_index: -1,
      roleForEdit: {
        id: null,
        name: null,
        permissions: []
      }
    };
  },

  methods: {
    getRoles() {
      this.loading = true;
      this.axios
        .get("roles")
        .then(res => {
          this.items = res.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    getAllPermissions() {
      this.axios.get("roles/create").then(resp => {
        this.roleForEdit.permissions = resp.data.data;
        this.roleForEdit.id = null;
        this.roleForEdit.name = null;
      });
    },
    setForEdit(item) {
      this.edit_index = this.items.indexOf(item);
      // set item permisssions
      this.roleForEdit.permissions = Object.assign(
        {},
        this.roleForEdit.permissions,
        item.permissions
      );
      this.roleForEdit.id = item.id;
      this.roleForEdit.name = item.name;
      this.show = true;
    },

    setForDelete(item) {
      let vm = this;
      const index = this.items.indexOf(item);
      this.$alert().then(function() {
        vm.axios.delete("roles/" + item.id).then(resp => {
          if (resp.data.success) {
            vm.items.splice(index, 1);
            vm.$store.commit("showSnackbar", {
              show: true,
              text: resp.data.msg,
              stateType: "success"
            });
          } else {
            vm.$store.commit("showSnackbar", {
              show: true,
              stateType: "error",
              text: resp.data.msg
            });
          }
        });
      });
    },

    reset() {
      this.getAllPermissions();
      this.show = false;
      this.edit_index = -1;
    },

    saved(item) {
      if (this.edit_index == -1) this.items.push(item);
      else Object.assign(this.items[this.edit_index], item);
      this.reset();
    }
  },

  created() {
    this.getRoles();
    this.getAllPermissions();
  }
};
</script>
